import { INSERT, SELECT, UPDATE } from "@/utils/database_module"
import { SpecialOrderQuote } from "@/utils/types"


const specialOrderQuotes = {
    getAll : async () => {
        const specialOrderQuotes = await SELECT("special_order_quote" , { conditions : [{column : "is_deleted" , operator : "=" , value : 0}] , order : "display_order "}) as SpecialOrderQuote[];
        return specialOrderQuotes
    },

    insert : async (specialOrderQuotes : SpecialOrderQuote) => {
        return await INSERT("special_order_quote" , specialOrderQuotes )
    },

    update : async (id : number , specialOrderQuotes : Partial<SpecialOrderQuote>) => {
        return await UPDATE("special_order_quote" , specialOrderQuotes  , [{column : "id" , operator : "=" , value : id}])
     
    },

    delete : async (id : number) => {
        return await UPDATE("special_order_quote" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    },

}   

export default specialOrderQuotes;